var exports = {
  "h": "xa15a2ab7--ee98ff--status",
};

module.exports = exports;
